import { render, staticRenderFns } from "./MsMessageBoxV2.vue?vue&type=template&id=eef26b7c&scoped=true"
import script from "./MsMessageBoxV2.vue?vue&type=script&lang=js"
export * from "./MsMessageBoxV2.vue?vue&type=script&lang=js"
import style0 from "./MsMessageBoxV2.vue?vue&type=style&index=0&id=eef26b7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef26b7c",
  null
  
)

export default component.exports